export default function generateRandomColorCode() {
  return [Math.random(), Math.random(), Math.random()]
    .map(r => Math.floor(r * 255))
    .reduce((s, r) => s + r.toString(16).padStart(2, '0'), '#')
}
